function e(e,...t){return(...n)=>e(...t,...n)}export{e as partialBind};
//# sourceMappingURL=partialBind-DAdeydPI.js.map